<template>
  <div class="grid-cell">
    <a style="cursor: pointer" @click="previewProject()">{{ data.projectId }}</a>
  </div>
</template>

<script>
import { IframeParentCommnuicationService } from '@/services/IframeParentCommnuicationService';
export default {
  data() {
    return {};
  },
  methods: {
    previewProject() {
      const iframeParentCommnuicationService = new IframeParentCommnuicationService();
      const data = {
        action: 'eIn_CampaignDetail',
        campaignId: this.data.projectId,
        campaignType: this.data.campaignType,
      };
      return iframeParentCommnuicationService.SendMessageToParent(data);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: black;
}
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
